// write a function that returns true if the user is in dark mode

export const prefersDarkMode = () => {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  } catch (e) {
    return 'error';
  }
};

// QA tool function to override prefers-color-scheme media query
export const overridePrefersColorScheme = (darkMode: boolean) => {
  const originalMatchMedia = window.matchMedia;

  window.matchMedia = (query: string) => {
    if (query === '(prefers-color-scheme: dark)') {
      return {
        matches: darkMode,
        media: query,
        onchange: null,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        addListener: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        removeListener: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        addEventListener: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        removeEventListener: () => {},
        dispatchEvent: () => true,
      };
    }
    return originalMatchMedia.call(window, query);
  };
};

export const enableDarkMode = (darkMode: boolean) => {
  document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
};

export const setDarkModeBasedOnUserPreference = () => {
  if (prefersDarkMode()) {
    enableDarkMode(true);
    return true;
  } else {
    enableDarkMode(false);
    return false;
  }
};
